import { WbCargoType } from '../server/mpsklad_core/Entity/Enums/WbCargoType'

export const wbCargoTypeNames: {
  readonly [K in WbCargoType]: string
} = {
  [WbCargoType.Small]: 'МГТ',
  [WbCargoType.ExtraLarge]: 'СГТ',
  [WbCargoType.LargePlus]: 'КГТ+'
}